import { useEffect } from 'react';

interface SeoHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
  structuredData?: object;
}

export default function SeoHead({
  title,
  description,
  keywords,
  canonical,
  ogImage,
  structuredData,
}: SeoHeadProps) {
  useEffect(() => {
    // Update last-modified date
    const lastModifiedMeta = document.querySelector('meta[name="last-modified"]');
    if (lastModifiedMeta) {
      lastModifiedMeta.setAttribute('content', new Date().toISOString().split('T')[0]);
    }

    // Add structured data if provided
    if (structuredData) {
      const existingScript = document.getElementById('structured-data');
      if (existingScript) {
        existingScript.remove();
      }

      const script = document.createElement('script');
      script.id = 'structured-data';
      script.type = 'application/ld+json';
      script.text = JSON.stringify(structuredData);
      document.head.appendChild(script);
    }

    return () => {
      const script = document.getElementById('structured-data');
      if (script) {
        script.remove();
      }
    };
  }, [structuredData]);

  return null;
}
